import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import WorkDetail from './pages/WorkDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminWorkList from './pages/admin/AdminWorkList';
import AdminWorkNew from './pages/admin/AdminWorkNew';
import AdminWorkEdit from './pages/admin/AdminWorkEdit';
import AdminAboutEdit from './pages/admin/AdminAboutEdit';
import AdminContactEdit from './pages/admin/AdminContactEdit';
import AdminMessages from './pages/admin/AdminMessages';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './context/AuthContext';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#f8ff00] flex items-center justify-center">
        <p className="text-[#3d2b5e] text-2xl font-['Permanent_Marker']">Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/work/:id" element={<WorkDetail />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />

      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/work"
        element={
          <ProtectedRoute>
            <AdminWorkList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/work/new"
        element={
          <ProtectedRoute>
            <AdminWorkNew />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/work/edit/:id"
        element={
          <ProtectedRoute>
            <AdminWorkEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/about"
        element={
          <ProtectedRoute>
            <AdminAboutEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/contact"
        element={
          <ProtectedRoute>
            <AdminContactEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/messages"
        element={
          <ProtectedRoute>
            <AdminMessages />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;